import script from "./ProjectsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectsPage.vue?vue&type=style&index=0&id=529f1a61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-529f1a61"]])

export default __exports__